import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchGetProfesorName, IProfesorName } from 'api/profesor';

export const fetchProfesorData = createAsyncThunk('profesor/fetchProfesorData', async (profesorKey: string) => {
	const response = await fetchGetProfesorName(profesorKey);
	return response;
});

const initialState: IProfesorName = {} as IProfesorName;

const datosBaseProfesorStateSlice = createSlice({
	name: 'datosBaseProfesorState',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(fetchProfesorData.fulfilled, (state, action) => {
			return action.payload;
		});
	}
});

export default datosBaseProfesorStateSlice.reducer;
